import {
    useEffect,
} from 'react';

import {
    SimpleGrid,
    Table,
} from '@mantine/core';

import {useReportTypes} from '../hooks/useReportTypes';

import {
    SimpleTableBatchAction,
    TableBody,
    TableBodyColumn,
    TableHeaderColumn,
    TableHeaderRow,
} from '@flexinet/ui-components';
import {IReportTypeTableColumn} from '../types';
import {getColumns} from '../tables/columns';

export const RecordsTable = () => {

    const {
        visibleItems,
        loading,
        fetchRecords,
        handleFilterByKeyword,
    } = useReportTypes();

    useEffect(() => {
        fetchRecords();
    }, []);

    const tableColumns: IReportTypeTableColumn[] = getColumns();

    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <SimpleTableBatchAction
                limit={10}
                handleItemsPerPageChange={() => {}}
                handleFilterByKeyword={handleFilterByKeyword}
            />
            <Table verticalSpacing='sm' striped highlightOnHover>
                <TableHeaderRow
                    columns={tableColumns as unknown as TableHeaderColumn[]}
                />
                <TableBody
                    items={visibleItems}
                    loading={loading}
                    selection={{}}
                    columns={tableColumns as unknown as TableBodyColumn[]}
                />
            </Table>
        </SimpleGrid>
    );
};
